import { useId } from 'react';

export function SelectField({
    label,
    value,
    options,
    onChange,
    disabled = false,
    hidden = false,
    primary = false,
}) {
    const id = useId();
    if (hidden) return null;

    return (
        <div className={`col_field${primary ? ' primary' : ''}`}>
            <label className="field_title" htmlFor={id}>{label}</label>
            <select id={id} value={value} disabled={disabled} onChange={(e) => onChange(e.target.value)}>
                {options.map((option) => (
                    <option key={option.value} value={option.value} disabled={option.disabled}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    );
}

export function TextField({ label, value, onChange, disabled = false, hidden = false }) {
    const id = useId();
    if (hidden) return null;

    return (
        <div className="col_field">
            <label className="field_title" htmlFor={id}>{label}</label>
            <input
                id={id}
                type="text"
                inputMode="decimal"
                value={value}
                disabled={disabled}
                onChange={(e) => onChange(e.target.value)}
            />
        </div>
    );
}

export function CheckboxRow({ label, checked, onChange, disabled = false, hidden = false, mark }) {
    const id = useId();
    if (hidden) return null;

    return (
        <div className="checkbox_row">
            <input
                id={id}
                type="checkbox"
                checked={checked}
                disabled={disabled}
                onChange={(e) => onChange(e.target.checked)}
            />
            <label htmlFor={id}>
                {label}
                {mark && <span className="eva_error">{mark}</span>}
            </label>
        </div>
    );
}
